<template>
  <div>
    <a-form
      ref="addForm" :form="form" :disabled="$route.query.titless == '查看'"
      class="detail-form"
    >
      <div class="card-container">
        <div class="card-title subtitle">
          基础信息
        </div>
        <div class="card-content">
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="标题"
                v-bind="formItemLayout"
              >
                <a-input
                  v-decorator="[
                    'title',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写标题',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  :allow-clear="$route.query.titless == '添加子级'"
                  placeholder="请填写标题"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="标签"
                v-bind="formItemLayout"
              >
                <a-input
                  v-decorator="[
                    'label',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写标签',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  placeholder="请填写标签"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
              <a-form-item
                label="图片上传"
                :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
              >
                <a-upload
                  :disabled="$route.query.titless == '查看'"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="true"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :remove="handleRemove"
                  :max-count="1"
                  @preview="handlePreview"
                  @change="handleChange"
                >
                  <img v-if="imgUp && $route.query.title != '添加'" :src="imgUp" alt="avatar">
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      图片上传
                    </div>
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible" centered :footer="null"
                  @cancel="handleCancel"
                >
                  <img alt="example" style="width: 100%" :src="previewImage">
                </a-modal>
                <div class="upload-tip">
                  <a-icon class="tip-icon" type="info-circle" />车辆图片最多可以上传3张，每张大小不超过10M，格式为png，jpeg，jpg。
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="排序"
                v-bind="formItemLayout"
              >
                <a-input
                  v-decorator="[
                    'sort',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写排序',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  placeholder="请填写排序"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="选择"
                v-bind="formItemLayout"
              >
                <a-radio-group
                  v-decorator="[
                    'type',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请选择',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看' || $route.query.titless == '添加子级'"
                  @change="radioNew"
                >
                  <a-radio :value="0">
                    二手
                  </a-radio>
                  <a-radio :value="3">
                    借用
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="上级类别"
                v-bind="formItemLayout"
              >
                <a-select
                  v-model="sele"
                  v-decorator="['pid']"
                  :disabled="$route.query.titless == '查看' || $route.query.titless == '添加子级'"
                  allow-clear
                  placeholder="全部"
                  show-search
                  option-filter-prop="children"
                >
                  <a-select-option v-for="(item,index) in estateList" :key="index" :value="item.id">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <div class="card-content mb40 mt40">
          <a-row type="flex" justify="center">
            <a-col
              :span="12" type="flex" align="middle"
              style="text-align:center;"
            >
              <a-button
                v-if="$route.name === 'addGoods'" class="mr8"
                @click="reset"
              >
                重置
              </a-button>
              <a-button v-else class="mr8" @click="back">
                返回
              </a-button>
              <a-button
                v-if="$route.query.titless != '查看'"
                type="primary"
                @click="save"
              >
                保存
              </a-button>
            </a-col>
          </a-row>
        </div>
        <chooseSite
          ref="chooseMap"
          :map-dialog-obj="mapDialogObj"
          @getPosition="getPosition"
        />
      </div>
    </a-form>
  </div>
</template>

<script>
import { savePostHouse, findPostHouseList, recycleUserList, getPostHouseInfo, delPostHouse, goodsTypeList, saveHouseGoods, getTypeInfo } from '@/api/postManagement'
import imageUpload from '@/components/imageUpload/imageUpload.vue'
import moment from 'moment'
import { getAreaListData, addArea, delArea } from '@/api/areaManage'
import { getAreaList } from '@/api/common'
import { iconFontComponent, getArea } from '@/components/mixins/mixins.js'
import chooseSite from '@/components/map/chooseSite.vue'
export default {
  components: { imageUpload, chooseSite },
  mixins: [iconFontComponent, getArea],
  data () {
    return {
      form: this.$form.createForm(this, { name: 'addForm' }),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 17 }
      },
      merchantList: [],
      shopType: '5',
      isRestraint: 1,
      upperShelf: 0,
      downShelf: 0,
      showUpper: false,
      showDown: false,
      fileListGoods: [],
      fileListDetail: [],
      fileList: [],
      imageUrl: '',
      loading: false,
      optionsItem: [],
      labelList: [],
      allLabel: [],
      cityList: [],
      options: [],
      areaContain: [],
      areaNames: [],
      mapDialogObj: {
        visible: false
      },

      previewVisible: false,
      previewImage: '',
      managerId: '',
      estateList: [],
      estateLists: [],
      imgUp: '',
      positionInfo: null,
      sele: ''
      // title:
    }
  },
  mounted () {

    if (this.$route.query.titless == '添加子级') {
      // this.sele = this.$route.query.id
      // this.form.resetFields(
      //      　　 'title'
      //    　　)
      this.form.setFieldsValue({
        // label: res.result.label,
        // sort: res.result.sort,
        // type: res.result.type,
        title: null
        // pid: res.result.pidName

      })
    }
    // this.title = this.$route.query.title
    this.getArea('', 2, null, true)
    // this.recycleUserList()
    if (this.$route.query.id) {
      this.getPostHouseInfo()
    }
  },
  methods: {
    getPostHouseInfo () {
      const parems = {
        id: this.$route.query.id
      }
      getTypeInfo(parems).then(res => {
        if (this.$route.query.titless == '添加子级') {
          this.imgUp = ''
          this.form.setFieldsValue({
            label: '',
            sort: '',
            type: res.result.type,
            title: '',
            pid: res.result.pidName
          })
        } else {
          this.imgUp = res.result.path
          this.form.setFieldsValue({
            label: res.result.label,
            sort: res.result.sort,
            type: res.result.type,
            title: res.result.title,
            pid: res.result.pidName

          })
        }
      })
    },
    radioNew (val) {

      this.recycleUserList(val.target.value)
    },
    // 回收点管理人员列表
    recycleUserList (val) {
      const parems = {
        pid: 0,
        page: 1,
        pageSize: 1000,
        type: val
      }
      goodsTypeList(parems).then((res) => {
        this.estateList = res.result.list
        this.estateLists = res.result.list
      })
    },
    // 图片上传
    handleCancel () {
      this.previewVisible = false
    },
    beforeUpload (file) {
      if (this.fileList.length >= 1) {
        this.$message.error('最多可上传1张图片！')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      const isType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      if (!isLt2M) {
        this.$message.error('每张图片大小不能超过10M！')
        return false
      }
      if (!isType) {
        this.$message.error('请选择png，jpeg，jpg格式图片上传！')
        return false
      }
      return false
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleRemove (file) {
      this.fileList.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.fileList.splice(index, 1)
        }
      })
    },
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true)
    },
    onChange (value) {
      if (value.length <= 1) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            categoryId: []
          })
        })
      }
    },
    getAreaData (provinceId) {
      const newOptions = JSON.parse(JSON.stringify([...this.options]))
      newOptions.forEach(item => {
        if (item.id === provinceId) {
          getAreaList({
            id: item.id,
            layer: 3
          })
            .then(resp => {
              item.children = resp.result.data
              item.children.forEach(thing => {
                getAreaList({
                  id: thing.id,
                  layer: 4
                })
                  .then(respo => {
                    thing.children = respo.result.data
                  })
              })
            })
        }
      })
      this.options = newOptions
    },
    changeArea (value, options) {
      this.areaNames = []
      if (!options) return
      options.forEach(item => {
        this.areaNames.push(item.name)
      })
    },
    getPosition (positionInfo) { // 获取地区选取信息
      if (positionInfo.point) {
        this.positionInfo = positionInfo.point
        this.form.setFieldsValue({ pos: positionInfo.point.lng + ',' + positionInfo.point.lat })
      }
    },
    choosePos () {
      this.mapDialogObj.visible = true
      this.$refs.chooseMap.initMap()
    },

    changeShopType () {
      this.form.setFieldsValue({ 'integral': undefined })
    },
    getFlielistGoods (e) {
      this.fileListGoods = e
    },
    getFlielistDetail (e) {
      this.fileListDetail = e
    },
    handleGoods (e) {
      this.fileListGoods = e
    },
    goodsDel (e) {
      this.fileListDetail = e
    },
    handleDetail (e) {
      this.fileListGoods = e
    },
    detailDel (e) {
      this.fileListDetail = e
    },
    getMerchant () {
      this.$httpPost(this.$basePath.getMerchant, {})
        .then(res => {
          this.merchantList = res.result
        })
    },
    getLabel () {
      this.$httpPost(this.$basePath.getLabel, {})
        .then(res => {
          let arr = []
          const [arr1, arr2] = [[], []]
          this.allLabel = res.result
          res.result.forEach(item => {
            if (item.position === 1) {
              arr1.push(item)
            }
            if (item.position === 0) {
              arr2.push(item)
            }
          })
          arr = [arr1, arr2]
          this.labelList = arr
        })
    },
    loadDataItem (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getCategory(targetOption.id, 2, targetOption)
    },
    getCityList () {
      this.$httpPost(this.$basePath.getCityList, {})
        .then(res => {
          this.cityList = res.result
        })
    },
    getCategory (id, level, targetOption) {
      this.$httpPost(this.$basePath.getCategory, {
        pid: id
      })
        .then(res => {
          if (level === 1) {
            res.result.forEach(item => {
              item.isLeaf = false
            })
            this.optionsItem = res.result
          } else {
            this.$set(targetOption, 'children', res.result)
          }
        })
    },

    changeUpper () {
      if (this.upperShelf === 2) {
        this.showUpper = true
      } else {
        this.showUpper = false
      }
    },
    changeDown () {
      if (this.downShelf === 1) {
        this.showDown = true
      } else {
        this.showDown = false
      }
    },
    disabledDate (current) {
      // 不能选今天和今天之前的日期
      // return current && current < moment()
    },
    handleRemove (file) {
      // this.fileList.forEach((item, index) => {
      //   if (item.uid === file.uid) {
      //     this.fileList.splice(index, 1)
      //   }
      // })
    },
    handleChange ({ file, fileList }) {
      if (this.fileList.length === 1) {
        return false
      }
      var formdata = new FormData()
      formdata.append('file', file)
      var config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      this.$httpPost(this.$basePath.uploadImage, formdata, config)
        .then(res => {
          this.imgUp = res.result
          this.$message.success('上传成功！')
          fileList.forEach(item => {
            if (item.uid === file.uid) {
              Object.assign(item, {
                url: res.result
              })
            }
          })
          this.fileList = fileList
        })
    },
    save (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          var param = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
          param.path = this.imgUp
          if (this.$route.query.title === '编辑') {
            param.id = this.$route.query.id

            if (!param.pid || param.pid === '') {
              param.pid = '0'
            }
          }
          // if (param.pid === '') {
          //   param.pid = '0'
          // }
          if (this.sele == '') {
            param.pid = '0'
          }

          saveHouseGoods(param).then((res) => {
            this.$message.success(res.msg)
            this.$router.push({
              path: '/postManagement/trademark'
            })
          })
        }
      })
      // var param = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
      // param.path = this.imgUp
      // if (this.$route.query.title === '编辑') {
      //   param.id = this.$route.query.id
      // }
      // if (param.pid === '') {
      //   param.pid = '0'
      // }

      // console.log(param)

      // saveHouseGoods(param).then((res) => {
      //   this.$message.success(res.msg)
      //   this.$router.push({
      //     path: '/postManagement/trademark'
      //   })
      // })

      // var isRepeat = false
      // label && label.length && this.labelList.forEach(item1 => {
      //   var step = 0
      //   item1.forEach(item2 => {
      //     label.forEach(item3 => {
      //       if (item3 === item2.id) {
      //         step += 1
      //       }
      //     })
      //   })
      //   if (step > 1) {
      //     isRepeat = true
      //   }
      // })
      // if (isRepeat) {
      //   this.$message.warning('商品标签每种标签只可选择一个！')
      //   return
      // }
      // var param = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
      // param.shopType = this.shopType
      // param.categoryId && param.categoryId.length ? param.categoryId = param.categoryId[1] : ''
      // param.buyNum ? param.buyNum : param.buyNum = 1
      // param.isRestraint = this.isRestraint
      // param.region && param.region.length ? param.region = param.region.join(',') : ''
      // this.upperShelf === 0 ? param.state = 1 : param.state = 2
      // param.registerDate ? param.registerDate = moment(param.registerDate).format('YYYY-MM-DD HH:mm:ss') : ''
      // param.outDate ? param.outDate = moment(param.outDate).format('YYYY-MM-DD HH:mm:ss') : ''
      // if (!param.weights) param.weights = 1
      // if (!this.fileListGoods.length) {
      //   this.$message.warning('请上传商品图片！')
      //   return
      // } else {
      //   param.imageList = this.fileListGoods
      // }
      // if (this.fileListDetail.length) {
      //   param.detailsImgList = this.fileListDetail
      // }
      // if (this.$route.query.id) {
      //   param.id = this.$route.query.id
      // }
      // this.form.validateFields(err => {
      //   if (!err) {
      //     this.$httpPost(this.$basePath.merchantEdit, param)
      //       .then(res => {
      //         this.$message.success('操作成功')
      //         if (this.upperShelf === 0) {
      //           this.$router.push({
      //             path: '/goods/phyGoodsManage/groundGoods'
      //           })
      //         } else {
      //           this.$router.push({
      //             path: '/goods/phyGoodsManage/houseGoods'
      //           })
      //         }
      //       })
      //   }
      // })
    },
    back () {
      this.$router.go(-1)
    },
    reset () {
      this.form.resetFields()
      this.$refs.goodsUpload.clear()
      this.$refs.detailUpload.clear()
      this.shopType = 5
      this.isRestraint = 1
      this.upperShelf = 0
      this.downShelf = 0
      this.showDown = false
      this.showUpper = false
    }
  }
}
</script>
<style scoped>
  .ant-calendar-picker {
    width:100%
  }
</style>
<style lang="stylus" scoped>
.card-title.subtitle
  font-size 14px
.upload-tip
  font-size 12px
  color #999999
  .tip-icon
    margin-right 6px
</style>
